import React, { useState, useEffect } from "react";
import { useAtom } from "jotai";
import { FormGroup, Label, Input, Button } from "reactstrap";
import Sites from "../handlers/Sites-handler";
import { siteAtom } from "../../atoms/SiteAtom";
import useDownloadDataHandler from "../handlers/DownloadData-handler";

const DownloadForm = () => {
  const [site] = useAtom(siteAtom);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isSameDay, setIsSameDay] = useState(false);
  const [fileFormat, setFileFormat] = useState("csv");

  const [uid, setUid] = useState(null);
  const [startTimestamp, setStartTimestamp] = useState("");
  const [endTimestamp, setEndTimestamp] = useState("");
  const [table, setTable] = useState("");

  const { data, isLoading, isError, error, refetch } = useDownloadDataHandler(
    uid,
    table,
    startTimestamp,
    endTimestamp
  );

useEffect(() => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const dayDifference = (end - start) / (1000 * 60 * 60 * 24);

  setIsSameDay(startDate && endDate && (dayDifference === 0 || dayDifference === 1));
}, [startDate, endDate]);


const handleSubmit = () => {
  if (!site?.SiteUID) {
    alert("Please select a site.");
    return;
  }

  if (!startDate || !endDate) {
    alert("Please select valid start and end dates.");
    return;
  }

  const start = new Date(`${startDate}T${startTime || "00:00:00"}`);
  const end = new Date(`${endDate}T${endTime || "23:59:59"}`);

  const timeDifferenceInHours = (end - start) / (1000 * 60 * 60);

  const yearDiff = end.getFullYear() - start.getFullYear();
  if (yearDiff > 1 || (yearDiff === 1 && end.getMonth() > start.getMonth())) {
    alert("The date range cannot span more than a year.");
    return;
  }

  const startTs = start.toISOString();
  const endTs = end.toISOString();

  setUid(site.SiteUID);
  setStartTimestamp(startTs);
  setEndTimestamp(endTs);

  // Determine table type based on exact time range
  setTable(timeDifferenceInHours > 24 ? "Data" : "FastData");

  refetch(); // Trigger the fetch after all parameters are set
};


  const handleDownload = () => {
    if (!data) {
      alert("No data available for download.");
      return;
    }

    let fileContent;
    if (fileFormat === "csv") {
      const keys = Object.keys(data[0] || {});
      const csvHeader = keys.join(",");
      const csvRows = data.map((row) => keys.map((key) => row[key]).join(","));
      fileContent = [csvHeader, ...csvRows].join("\n");
    } else {
      fileContent = JSON.stringify(data, null, 2);
    }

    const blob = new Blob([fileContent], {
      type: fileFormat === "csv" ? "text/csv" : "text/plain",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `data.${fileFormat === "csv" ? "csv" : "txt"}`;
    link.click();
    URL.revokeObjectURL(link.href); // Cleanup
  };

  return (
    <div>
      <h3>Select Site and Parameters</h3>
      <Sites />
      <FormGroup>
        <Label for="startDate">Start Date</Label>
        <Input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="endDate">End Date</Label>
        <Input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </FormGroup>
      {isSameDay && (
        <>
          <FormGroup>
            <Label for="startTime">Start Time</Label>
            <Input
              type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="endTime">End Time</Label>
            <Input
              type="time"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </FormGroup>
        </>
      )}
      <FormGroup>
        <Label for="fileFormat">File Format</Label>
        <Input
          type="select"
          value={fileFormat}
          onChange={(e) => setFileFormat(e.target.value)}
        >
          <option value="csv">CSV</option>
          <option value="text">Text File</option>
        </Input>
      </FormGroup>

      <Button
        style={{ backgroundColor: "#61a0a8", borderColor: "#61a0a8" }}
        onClick={isLoading ? null : handleSubmit}
        disabled={isLoading}
      >
        {isLoading ? "Loading..." : "Submit"}
      </Button>

      {data && (
        <Button
          style={{ backgroundColor: "#919e8b", borderColor: "#919e8b" }}
          onClick={handleDownload}
        >
          Download
        </Button>
      )}

      {isError && <div className="text-danger">Error: {error.message}</div>}
    </div>
  );
};

export default DownloadForm;
